
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class LiveWidgetInternal
 * @hideconstructor
 * @classdesc Implements LiveWidgetInternalAPI
 */
define([
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/LiveWidgetInternalAPI'
], (APIFactory, LiveWidgetInternalAPI) => {
	class LiveWidgetInternal {

		constructor(options) {
			this.widget = options.widget;
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [LiveWidgetInternalAPI]);
			}
			return this.api;
		}

		getWidget() {
			return this.widget;
		}

		getVisView() {
			return this.widget.getCurrentVis();
		}

		getPropertySupport() {
			return this.widget.visModelManager.propertySupport;
		}

	}

	return LiveWidgetInternal;
});
